import React from "react";
import { EditAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";

const ActionButtons = ({ id, customerId, name, mutation, history }) => {
  const [deleteCustomer] = useMutation(mutation);

  return (
    <>
      <Restricted permissions={[permissions.customer_manage]}>
        <EditAction url={`/customer/edit/${id}`} />
        <DeleteActionWithModal
          actionButton
          urlOnSuccess="/customer/list"
          history={history}
          mutation={deleteCustomer}
          mutationVariables={{
            customerId: id,
          }}
          elementNameInResult="deleteCustomer"
          elementToDelete={name}
        />
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Nombre del elemento
   **/
  name: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object.isRequired,
};

export default ActionButtons;
